import { makeStyles } from '@material-ui/core';
import CustomLogo from './logo/konfio-logo-app.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 42,
    marginLeft: '-10px',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img alt="Konfio Full Logo" className={classes.image} src={CustomLogo} />
  );
};

export default LogoFull;
